import { withJsonFormsControlProps } from '@jsonforms/react'

import {
  FavoriteAutocomplete,
  autocompleteTester,
} from '../element/Autocomplete'
import { FavoriteCheckbox, checkboxTester } from '../element/Checkbox'
import {
  FavoriteCheckboxGroup,
  checkboxGroupTester,
} from '../element/CheckboxGroup'
import {
  FavoriteCheckboxInput,
  checkboxInputTester,
} from '../element/CheckboxInput'
import { FavoriteDate, dateTester } from '../element/Date'
import { FavoriteDateTime, dateTimeTester } from '../element/DateTime'
import { FavoriteInput, inputTester } from '../element/Input'
import { FavoriteInputSearch, inputSearchTester } from '../element/InputSearch'
import { FavoriteInputMask, inputMaskTester } from '../element/InputMask'
import { FavoriteNumber, numberTester } from '../element/Number'
import { FavoriteRadio, radioTester } from '../element/Radio'
import { FavoriteSelect, selectTester } from '../element/Select'
import { FavoriteTextarea, textareaTester } from '../element/Textarea'
import { FavoriteTime, timeTester } from '../element/Time'
import { FavoriteTableDisplay, tableTester } from '../element/Table'
import {
  FavoriteCustomTableDisplay,
  customTableTester,
} from '../element/CustomTable'
import { FavoriteColorPicker, colorPickerTester } from '../element/ColorPicker'

export const favoriteRenderer = {
  checkbox: {
    tester: checkboxTester,
    renderer: withJsonFormsControlProps(FavoriteCheckbox),
  },
  checkboxGroup: {
    tester: checkboxGroupTester,
    renderer: withJsonFormsControlProps(FavoriteCheckboxGroup),
  },
  checkboxInput: {
    tester: checkboxInputTester,
    renderer: withJsonFormsControlProps(FavoriteCheckboxInput),
  },
  date: {
    tester: dateTester,
    renderer: withJsonFormsControlProps(FavoriteDate),
  },
  dateTime: {
    tester: dateTimeTester,
    renderer: withJsonFormsControlProps(FavoriteDateTime),
  },
  time: {
    tester: timeTester,
    renderer: withJsonFormsControlProps(FavoriteTime),
  },
  input: {
    tester: inputTester,
    renderer: withJsonFormsControlProps(FavoriteInput),
  },
  inputSearch: {
    tester: inputSearchTester,
    renderer: withJsonFormsControlProps(FavoriteInputSearch),
  },
  inputMask: {
    tester: inputMaskTester,
    renderer: withJsonFormsControlProps(FavoriteInputMask),
  },
  number: {
    tester: numberTester,
    renderer: withJsonFormsControlProps(FavoriteNumber),
  },
  textarea: {
    tester: textareaTester,
    renderer: withJsonFormsControlProps(FavoriteTextarea),
  },
  radio: {
    tester: radioTester,
    renderer: withJsonFormsControlProps(FavoriteRadio),
  },
  select: {
    tester: selectTester,
    renderer: withJsonFormsControlProps(FavoriteSelect),
  },
  autocomplete: {
    tester: autocompleteTester,
    renderer: withJsonFormsControlProps(FavoriteAutocomplete),
  },
  table: {
    tester: tableTester,
    renderer: withJsonFormsControlProps(FavoriteTableDisplay),
  },
  customTable: {
    tester: customTableTester,
    renderer: withJsonFormsControlProps(FavoriteCustomTableDisplay),
  },
  colorPicker: {
    tester: colorPickerTester,
    renderer: withJsonFormsControlProps(FavoriteColorPicker),
  },
}
